/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResumeAgentScheduleRequest = {
  agentId: string;
  scheduleId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const ResumeAgentScheduleRequest$inboundSchema: z.ZodType<
  ResumeAgentScheduleRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  agent_id: z.string(),
  schedule_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "agent_id": "agentId",
    "schedule_id": "scheduleId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type ResumeAgentScheduleRequest$Outbound = {
  agent_id: string;
  schedule_id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const ResumeAgentScheduleRequest$outboundSchema: z.ZodType<
  ResumeAgentScheduleRequest$Outbound,
  z.ZodTypeDef,
  ResumeAgentScheduleRequest
> = z.object({
  agentId: z.string(),
  scheduleId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    agentId: "agent_id",
    scheduleId: "schedule_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function resumeAgentScheduleRequestToJSON(
  resumeAgentScheduleRequest: ResumeAgentScheduleRequest,
): string {
  return JSON.stringify(
    ResumeAgentScheduleRequest$outboundSchema.parse(resumeAgentScheduleRequest),
  );
}
export function resumeAgentScheduleRequestFromJSON(
  jsonString: string,
): SafeParseResult<ResumeAgentScheduleRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResumeAgentScheduleRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResumeAgentScheduleRequest' from JSON`,
  );
}
